import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import GroupIcon from '@mui/icons-material/Group';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../../routes';
import { DEFAULT_LIST_ID } from '../../../../sic-lib/defaults';
import { ListType } from '../../../../sic-lib/types/Lists';
import { useAppDispatch } from '../../../../store/hooks';
import { setSidebar } from '../../../../store/sidebarDrawer';
import NavLinkListItem from '../../../Navigation/NavLinkListItem/NavLinkListItem';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        /* Important for height to be inforced because is a virtual list */
        height: '57px',
        overflow: 'hidden',
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    item: {
        listStyle: 'none',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
}));

interface Props {
    listId: number;
    name: string;
    type: ListType;
}

export default function GroupsListItem({ listId, name, type }: Props) {
    const { classes, cx } = useStyles();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkSelected = location.pathname.toLowerCase() === contactRoutes.setGroups(listId);

        setIsSelected(checkSelected);
    }, [location]);

    const [icon, setIcon] = React.useState<React.ReactElement | null>(null);

    React.useEffect(() => {
        switch (type) {
            case ListType.static:
                setIcon(<GroupIcon />);
                break;
            case ListType.dynamic:
                setIcon(<FilterListIcon />);
                break;
            default:
                setIcon(null);
        }
    }, [type]);

    const handleSetShowList = () => {
        dispatch(setSidebar({ groupsList: listId }));
    };

    return (
        <NavLinkListItem
            pathname={contactRoutes.setGroups(listId)}
            selected={isSelected}
            ContainerProps={{
                className: classes.root,
            }}
            ContainerComponent="div"
            className={cx(
                listId !== DEFAULT_LIST_ID && classes.item,
                listId === DEFAULT_LIST_ID && classes.root,
            )}
        >
            <ListItemAvatar>
                <Avatar variant="rounded">{icon}</Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={name}
                primaryTypographyProps={{
                    className: classes.primaryText,
                    noWrap: true,
                }}
            />
            <ListItemSecondaryAction>
                <IconButton araia-label="Expand list" onClick={handleSetShowList} size="large">
                    <ExpandMoreIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </NavLinkListItem>
    );
}
